import styled from 'styled-components'

export const Container = styled.div<{ isComplete: boolean }>`
  height: 24px;
  width: 24px;
  margin: 5px 10px 0 0;
  min-height: 24px;
  min-width: 24px;
  max-height: 24px;
  max-width: 24px;
  border-radius: 50%;
  border: 1px solid ${({ isComplete }) => isComplete ? '#3D6666' : '#C8C8C8'};
  background: ${({ isComplete }) => isComplete ? '#3D6666' : '#FFFFFF'};
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
  color: #353744;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 85%;
    height: 85%;
  }
`